var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"question-share__bottom"},[_c('div',{staticClass:"question-share__bottom-button",on:{"click":_vm.download}},[_vm._v("打开快对AI查看")])])}
var staticRenderFns = []

export { render, staticRenderFns }